module.exports = __webpack_public_path__ + "img/male.3686e5c4.svg";